export default {
  AVAILABLE: 'AVAILABLE', // доступен для записи
  PASSED: 'PASSED', // урок прошел (уже в прошлом по дате и времени)
  IN_PROGRESS: 'IN_PROGRESS', // урок идет
  SIGNED: 'SIGNED', // записан
}
